import memoize from 'memoize-one';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
const isNodeWithCallback = (node) => {
    return (node.nodeType === FlowNodeTypes.CALLBACK ||
        (node.nodeType === FlowNodeTypes.QUEUE && !!node.payload.callbackInfo));
};
const getParentNode = (actions, action) => (action.parentId !== null ? (actions === null || actions === void 0 ? void 0 : actions[action.parentId]) || null : null);
export const getRelevantAncestorWithCallback = memoize((actions, action) => {
    let greatestAncestorWithCallback = null;
    let parent = null;
    let currentNode = action;
    while ((parent = getParentNode(actions, currentNode))) {
        currentNode = parent;
        if (isNodeWithCallback(parent)) {
            // callbacks override the callback-settings
            // so the first one encountered will be the correct one
            if (parent.nodeType === FlowNodeTypes.CALLBACK)
                return parent;
            // queues inherit the callback settings so we need the one furthest up
            greatestAncestorWithCallback = parent;
        }
    }
    return greatestAncestorWithCallback;
});
export const getAncestorWithCallback = memoize((actions, action) => {
    const parent = getParentNode(actions, action);
    if (!parent)
        return null;
    if (parent.nodeType === FlowNodeTypes.INIT) {
        return null;
    }
    if (isNodeWithCallback(parent)) {
        return parent;
    }
    if (parent) {
        return getAncestorWithCallback(actions, parent);
    }
    return null;
});
export const hasAncestralCallback = memoize((actions, action) => {
    const nodeWithCallback = getAncestorWithCallback(actions, action);
    return nodeWithCallback !== null;
});
